module.exports = __webpack_public_path__ + "img/grid.d784cda1.png";